export default "__VITE_ASSET__12253e84__"